import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"

const pageCount = 6

class StartGuide extends Controller {
  static values = {
    state: String,
  }
  static targets = [`dotNav`, `page`]

  stateValueChanged() {
    this.currentPage = 1
    if (this.stateValue == `open`) {
      this.currentPage = 0
      this.togglePage()
      this.element.showModal()
    }

    if (this.stateValue == `closed`) {
      this.element.close()
    }
  }

  goToPage(evt) {
    let target = evt.target

    if (evt.target.dataset.startGuidePage == undefined) {
      target = target.parentNode
    }

    this.currentPage = parseInt(target.dataset.startGuidePage)
    this.togglePage()
  }

  goToNextPage() {
    if (this.currentPage == pageCount - 1) {
      this.currentPage = 0
    } else {
      this.currentPage += 1
    }

    this.togglePage()
  }

  close() {
    this.element.dataset.startGuideStateValue = `closed`
  }

  togglePage() {
    this.element.classList.remove(`start-guide-first`)
    this.element.classList.remove(`start-guide-last`)

    if (this.currentPage == 0) {
      this.element.classList.add(`start-guide-first`)
    }

    if (this.currentPage == pageCount - 1) {
      this.element.classList.add(`start-guide-last`)
    }

    this.pageTargets.forEach((el) => {
      el.classList.remove(`start-guide__page-current`)
    })

    this.dotNavTargets.forEach((el) => {
      el.classList.remove(`start-guide__dot-current`)
    })

    this.pageTargets[this.currentPage].classList.add(
      `start-guide__page-current`
    )
    this.dotNavTargets[this.currentPage].classList.add(
      `start-guide__dot-current`
    )
  }
}

Stimulus.register(`start-guide`, StartGuide)
